import {
  canGoToNextStep,
  canGoToPreviousStep,
  getCurrentStep,
  goToNextStep,
  goToPreviousStep,
  IWizardStepProps,
  SubwayNavNodeState,
  WizardActionBar,
} from '@coherence-design-system/controls';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import * as React from 'react';

import { MachineLearningExperimentWizardStep } from './MachineLearningExperimentWizard';
import {
  MachineLearningExperimentWizardContext,
  MachineLearningExperimentWizardContextProps,
} from './MachineLearningExperimentWizardContext';

export type MachineLearningExperimentWizardFooterProps = {
  completedSteps: MachineLearningExperimentWizardStep[];
  steps: IWizardStepProps[];
  onStepChanged(steps: IWizardStepProps[]): void;
};

export function MachineLearningExperimentWizardFooter(): React.ReactElement {
  const { steps, setSteps, completedSteps, experiment, dismiss } =
    React.useContext<MachineLearningExperimentWizardContextProps>(MachineLearningExperimentWizardContext);
  const { httpClient } = React.useContext(Context as React.Context<IEmployeeExperienceContext>);

  const currentStep = getCurrentStep(steps);
  const viewState =
    completedSteps.indexOf(currentStep.id as MachineLearningExperimentWizardStep) > -1
      ? SubwayNavNodeState.Completed
      : SubwayNavNodeState.ViewedNotCompleted;

  const handleSubmitButtonPressed = () => {
    httpClient
      .post(`${__API_BASE_URL__}/machine-learning/experiments`, {
        resource: __CLIENT_ID__,
        data: experiment,
      })
      .then(() => {
        dismiss();
      });
  };

  return (
    <WizardActionBar
      backAction={{
        text: 'Back',
        onClick: () => {
          if (canGoToPreviousStep(steps)) {
            const { steps: newSteps } = goToPreviousStep(steps, viewState);
            setSteps(newSteps);
          }
        },
      }}
      mainAction={
        currentStep.id === MachineLearningExperimentWizardStep.REVIEW
          ? { text: 'Submit', onClick: handleSubmitButtonPressed, disabled: completedSteps.length < steps.length }
          : {
              text: 'Next',
              onClick: () => {
                if (canGoToNextStep(steps)) {
                  const { steps: newSteps } = goToNextStep(steps, viewState);
                  setSteps(newSteps);
                }
              },
            }
      }
      cancelAction={{
        text: 'Cancel',
        onClick: () => dismiss(),
      }}
      currentStep={{} as IWizardStepProps}
    />
  );
}
